export default __webpack_public_path__ + "static/DSC_0108-a3d78163eb18d7bf88ce3888f28da43b.jpg";